import React from 'react';
import { Header } from 'semantic-ui-react';
import CustomModal from '../CustomModal';
import POSAnimatedImage from '../POSAnimatedImage';

export const ErrorMessageWithActions = ({
  errorText,
  actions,
}: {
  errorText: string | undefined;
  actions: React.ReactNode;
}) => {
  debugger;
  return (
    <CustomModal
      header={
        <Header className="error-header" as={'h2'}>
          <POSAnimatedImage image="ExpertBlackDelay" />
          <span>Oops!</span>
        </Header>
      }
      closeIcon={false}
      open
    >
      <CustomModal.Content>
        <p>{errorText || 'Something went wrong.'}</p>
        {actions}
      </CustomModal.Content>
    </CustomModal>
  );
};
